const customFieldTypeDisplayArray = (type: string, location = 'preflight'): string[] => {
  if (!type) return [];

  const typesObject = {
    number: {
      preflight: ['min', 'max', 'default', 'precision', 'display_previous_value', 'unit', 'show_only', 'insert_after'],
      postflight: ['min', 'max', 'default', 'precision', 'display_previous_value', 'unit', 'show_only', 'insert_after'],
      trip: ['min', 'max', 'default', 'precision', 'display_previous_value', 'unit', 'insert_after'],
      trip_update: ['min', 'max', 'default', 'precision', 'unit'],
      mx_check: ['default', 'precision', 'display_previous_value', 'process_order'],
    },
    counter: {
      preflight: ['min', 'max', 'default', 'precision', 'unit', 'show_only', 'insert_after'],
      postflight: ['min', 'max', 'default', 'precision', 'unit', 'show_only', 'insert_after'],
      trip: ['min', 'max', 'default', 'precision', 'unit', 'insert_after'],
      trip_update: ['min', 'max', 'default', 'precision', 'unit'],
      mx_check: ['default', 'precision', 'process_order'],
    },
    string: {
      preflight: ['min', 'max', 'default', 'display_previous_value', 'unit', 'show_only', 'insert_after'],
      postflight: ['min', 'max', 'default', 'display_previous_value', 'unit', 'show_only', 'insert_after'],
      trip: ['min', 'max', 'default', 'display_previous_value', 'unit', 'insert_after'],
      trip_update: ['min', 'max', 'default', 'unit'],
      mx_check: ['default', 'display_previous_value', 'process_order'],
    },
    text: {
      preflight: ['min', 'max', 'default', 'display_previous_value', 'unit', 'show_only', 'insert_after'],
      postflight: ['min', 'max', 'default', 'display_previous_value', 'unit', 'show_only', 'insert_after'],
      trip: ['min', 'max', 'default', 'display_previous_value', 'unit', 'insert_after'],
      trip_update: ['min', 'max', 'default', 'unit'],
      mx_check: ['default', 'display_previous_value', 'process_order'],
    },
    boolean: {
      preflight: ['insert_after', 'show_only'],
      postflight: ['insert_after', 'show_only'],
      trip: ['insert_after'],
      trip_update: [],
      mx_check: ['process_order'],
    },
    attachment: {
      preflight: ['insert_after', 'show_only'],
      postflight: ['insert_after', 'show_only'],
      trip: ['insert_after'],
      trip_update: [],
      mx_check: ['process_order'],
    },
    date: {
      preflight: ['mode', 'unit', 'insert_after', 'show_only', 'display_previous_value'],
      postflight: ['mode', 'unit', 'insert_after', 'show_only', 'display_previous_value'],
      trip: ['mode', 'unit', 'insert_after', 'display_previous_value'],
      trip_update: ['mode', 'unit'],
      mx_check: ['mode', 'process_order', 'display_previous_value'],
    },
    selector: {
      preflight: ['options', 'unit', 'insert_after', 'show_only'],
      postflight: ['options', 'unit', 'insert_after', 'show_only'],
      trip: ['options', 'unit', 'insert_after'],
      trip_update: ['options', 'unit'],
      mx_check: ['process_order'],
    },
    duration: {
      preflight: ['interval', 'unit', 'insert_after', 'show_only'],
      postflight: ['interval', 'unit', 'insert_after', 'show_only'],
      trip: ['interval', 'unit', 'insert_after'],
      trip_update: ['interval', 'unit'],
      mx_check: ['interval', 'process_order'],
    },
  };

  const newArray = typesObject[type]?.[location] || [];

  return newArray;
};

export default customFieldTypeDisplayArray;
